import { Component } from '@angular/core';
import { EntitySelectorComponent } from '@app/selection/entity-selector.component';
import { AssetGroup } from '@app/_models/_DTOs/assetGroup';
import { AssetGroupService } from '@app/_services/assetGroup.service';

@Component({
    selector: 'app-assetGroup-selector',
    templateUrl: './assetGroup-selector.component.html',
    styleUrls: ['./assetGroup-selector.component.css']
})
export class AssetGroupSelectorComponent extends EntitySelectorComponent<AssetGroup> {


    constructor(
        private assetGroupService: AssetGroupService
    ) {
        super(assetGroupService);
    }
}